'use strict';

module.exports = {
  NOT_INITIALIZED: -1,
  PENDING_ADD_STARTING: 0,
  PENDING_ADD_VERIFYING_DNS: 1,
  PENDING_ADD_VERIFYING_SITE: 2,
  ADDED: 3,
  PENDING_DELETE: 4,
  DELETED: 5,
  INTERNAL_ERROR: 6,
  EXTERNAL_ERROR: 7
};